import { useHref } from 'react-router';

const useInitialRouteData = <T,>(): T => {
  const href = useHref('');
  const routesData = globalThis.__introwise_initial_data?.routes;
  return routesData?.[href];
};

export default useInitialRouteData;
